// import logo from './logo.svg';
import React from 'react';
import './App.css';
import Restaurant from "./components/Restaurant"

function App() {
  return(
    <>
     
    <Restaurant/>
    </>
  )
}

export default App;
